var $afa6d5819988437d$exports = {};
$afa6d5819988437d$exports = {
  "backButton": args => "\xC5terg\xE5 till ".concat(args.prevMenuButton),
  "moreActions": "Fler \xE5tg\xE4rder",
  "unavailable": "Ej tillg\xE4nglig, expandera f\xF6r mer information"
};
export { $afa6d5819988437d$exports as default };